function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Tool_Dibujar"
}, React.createElement("rect", {
  width: 48,
  height: 48
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Tool_Dibujar",
  "data-name": "Tool Dibujar",
  clipPath: "url(#clip-Tool_Dibujar)"
}, React.createElement("g", {
  id: "Icono",
  transform: "translate(4 4)",
  fill: "none",
  stroke: "#091832",
  strokeWidth: 2
}, React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 9,
  stroke: "none"
}), React.createElement("rect", {
  x: 1,
  y: 1,
  width: 38,
  height: 38,
  rx: 8,
  fill: "none"
})), React.createElement("path", {
  id: "Path_141",
  "data-name": "Path 141",
  d: "M5727.05,1117.992",
  transform: "translate(-5715 -1096)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), React.createElement("path", {
  id: "Path_144",
  "data-name": "Path 144",
  d: "M20.469,27.491a3.525,3.525,0,0,1-2.547-1.046,3.065,3.065,0,0,1-.84-2.651,1.863,1.863,0,0,0-.531-1.757,1.493,1.493,0,0,0-1.1-.5,6.734,6.734,0,0,0-2.547.923,10.216,10.216,0,0,1-4.575,1.414,7.245,7.245,0,0,1-5.124-2.411C-.729,17.6,1.01,10.122,5.2,6.015a14.16,14.16,0,0,1,19.757,0,13.538,13.538,0,0,1,0,19.384C24.867,25.485,22.792,27.491,20.469,27.491ZM6.981,7.834C3.4,11.351,2.453,17.154,4.994,19.646a4.783,4.783,0,0,0,3.338,1.681,6.776,6.776,0,0,0,3.021-.939l.413-.205c1.822-.912,2.526-1.192,3.689-1.192a4.019,4.019,0,0,1,2.883,1.225,4.4,4.4,0,0,1,.949,1.328A4.061,4.061,0,0,1,19.64,23a6.918,6.918,0,0,1-.012.939c-.026.467-.015.562.009.6a.417.417,0,0,0,.07.083.985.985,0,0,0,.762.317,4.68,4.68,0,0,0,2.7-1.363,10.989,10.989,0,0,0,0-15.744,11.611,11.611,0,0,0-16.187,0Zm1.666,9.46A2.549,2.549,0,1,0,6.1,14.745a2.549,2.549,0,0,0,2.549,2.549Zm5.417-5.1a2.23,2.23,0,1,0-2.23-2.23,2.23,2.23,0,0,0,2.23,2.23Zm6.691,1.275a1.912,1.912,0,1,0-1.912-1.912,1.912,1.912,0,0,0,1.912,1.912Zm2.549,5.1a1.912,1.912,0,1,0-1.912-1.912A1.912,1.912,0,0,0,23.3,18.569Z",
  transform: "translate(8.98 9.255)",
  fill: "#091832",
  fillRule: "evenodd"
}));

var SvgToolDibujar1 = function SvgToolDibujar1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgToolDibujar1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tool Dibujar-1.7c379ea3.svg";
export { ForwardRef as ReactComponent };